import { render, staticRenderFns } from "./MeddraModal.vue?vue&type=template&id=b2598bbe"
import script from "./MeddraModal.vue?vue&type=script&lang=js"
export * from "./MeddraModal.vue?vue&type=script&lang=js"
import style0 from "./MeddraModal.vue?vue&type=style&index=0&id=b2598bbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports